import moment from 'moment';
import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';

export default {
  all(city) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city)
      .collection('offers')
      .get()
      .then(docs => {
        return Firestore.getCollectionData(docs);
      });
  },

  manage(city, offer) {
    const {
      docId,
      label,
      amount,
      startDate,
      endDate,
      maxSpent,
      minSpent,
      active = false
    } = offer;

    const offerObj = {
      label,
      amount,
      startDate: moment(startDate)
        .toDate()
        .valueOf(),
      endDate: moment(endDate)
        .toDate()
        .valueOf(),
      maxSpent,
      minSpent,
      active
    };

    const promise = docId
      ? Firebase.firestore()
          .collection('cities')
          .doc(city)
          .collection('offers')
          .doc(docId)
          .update(offerObj)
      : Firebase.firestore()
          .collection('cities')
          .doc(city)
          .collection('offers')
          .add(offerObj);

    return promise;
  },

  deleteOffer(city, offer) {
    return Firebase.firestore()
      .collection('cities')
      .doc(city)
      .collection('offers')
      .doc(offer)
      .delete();
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/Offers/service.js